import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../lib/axios'

export const usePortalAuthStore = defineStore('portalAuth', () => {
    const customer = ref(null)
    const ready    = ref(false)

    async function fetchUser() {
        try {
            const { data } = await api.get('/portal/auth/user')
            customer.value = data.data
        } catch {
            customer.value = null
        } finally {
            ready.value = true
        }
    }

    async function sendOtp(email) {
        await api.get('/sanctum/csrf-cookie', { baseURL: '' })
        return api.post('/portal/auth/send-otp', { email })
    }

    async function verifyOtp(email, code) {
        const { data } = await api.post('/portal/auth/verify-otp', { email, code })
        customer.value = data.data
        return data
    }

    async function logout() {
        await api.post('/portal/auth/logout')
        customer.value = null
        ready.value = false

        // Reset portal context state and localStorage
        const { usePortalContextStore } = await import('./portalContext')
        usePortalContextStore().reset()
    }

    const isAuthenticated = () => customer.value !== null

    return { customer, ready, fetchUser, sendOtp, verifyOtp, logout, isAuthenticated }
})
